import * as yup from 'yup'

export const undefinedable = (schema: yup.StringSchema) =>
  schema.transform((value, originalValue) => {
    if (typeof originalValue === 'string') {
      return originalValue?.trim() === '' ? undefined : value
    }
    return value ?? undefined
  })

export const numberSchema = (msg: string) =>
  undefinedable(yup.string().matches(/^\d+(\.\d+)?$/, msg))
